var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValidCertificateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.840001 0.542969H15.96C16.1475 0.542969 16.3 0.695132 16.3 0.88346V11.8098C16.3 11.9982 16.1475 12.1503 15.96 12.1503H0.840001C0.652493 12.1503 0.5 11.9982 0.5 11.8098V0.88346C0.5 0.695137 0.652498 0.542969 0.840001 0.542969Z",
    stroke: "#103045",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35999 3.40479H13.44",
    stroke: "#103045",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35999 6.34668H5.87999",
    stroke: "#103045",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35999 9.28857H5.04097",
    stroke: "#103045",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9199 11.3896C12.3117 11.3896 13.4399 10.2607 13.4399 8.86815C13.4399 7.47558 12.3117 6.34668 10.9199 6.34668C9.52815 6.34668 8.3999 7.47558 8.3999 8.86815C8.3999 10.2607 9.52815 11.3896 10.9199 11.3896Z",
    stroke: "#103045"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.92 14.3313L12.6 15.1718V10.7476C12.6 10.7476 12.1209 11.3896 10.92 11.3896C9.71904 11.3896 9.23999 10.7592 9.23999 10.7592V15.1718L10.92 14.3313Z",
    fill: "#103045",
    stroke: "#103045",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidCertificateIcon);
export default __webpack_public_path__ + "static/media/validCertificateIcon.843439e4ba8440972e9e9ea8f432e281.svg";
export { ForwardRef as ReactComponent };